import { render, staticRenderFns } from "./modal_edicao.vue?vue&type=template&id=15bb749c"
import script from "./modal_edicao.vue?vue&type=script&lang=js"
export * from "./modal_edicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports